import { render, staticRenderFns } from "./MNavFrame.vue?vue&type=template&id=6fe18dbe&"
import script from "./MNavFrame.vue?vue&type=script&lang=ts&"
export * from "./MNavFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports